/* bm-branches.js — uniform-size carousel + NON-BLOCKING intro animations (ES5) */
(function () {
  function easeInOutQuad(t){ return t<0.5 ? 2*t*t : -1+(4-2*t)*t; }
  function animateScrollLeft(el, to, duration){
    var start=el.scrollLeft, change=to-start, startTime=null;
    function step(ts){ if(!startTime) startTime=ts; var p=Math.min(1,(ts-startTime)/duration); el.scrollLeft=start+change*easeInOutQuad(p); if(p<1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  function getStep(track){
    var first=track.querySelector('.bm-card'); if(!first) return track.clientWidth;
    var cs=window.getComputedStyle(track); var gap=parseFloat(cs.columnGap||cs.gap||20)||0;
    return first.getBoundingClientRect().width + gap;
  }
  function atEnd(track){ return track.scrollLeft >= (track.scrollWidth - track.clientWidth - 2); }

  // Non-blocking intro animation: adds classes/vars only (never hides)
  function initIntro(root){
    var enabled = root.getAttribute('data-anim') === 'true';
    var type    = (root.getAttribute('data-anim-type') || 'fade-up').toLowerCase();
    var dur     = Math.max(0, parseInt(root.getAttribute('data-anim-duration') || '800', 10));
    var delay   = Math.max(0, parseInt(root.getAttribute('data-anim-delay') || '0', 10));
    var stagger = Math.max(0, parseInt(root.getAttribute('data-anim-stagger') || '50', 10));
    var ease    = root.getAttribute('data-anim-ease') || 'cubic-bezier(.2,.8,.2,1)';

    // set vars (do not hide)
    root.style.setProperty('--anim-dur', dur + 'ms');
    root.style.setProperty('--anim-ease', ease);
    root.style.setProperty('--anim-delay-container', delay + 'ms');

    // set animation type class
    var allowed = ['fade-in','fade-up','slide-left','slide-right','zoom-in'];
    for (var i=0;i<allowed.length;i++){ root.classList.remove('anim-'+allowed[i]); }
    root.classList.add('anim-' + (allowed.indexOf(type) >= 0 ? type : 'fade-up'));

    // per-card stagger
    var cards = root.querySelectorAll('.bm-card');
    for (var j=0;j<cards.length;j++){
      cards[j].style.setProperty('--delay', (delay + j*stagger) + 'ms');
    }

    // reveal trigger
    function reveal(){ root.classList.add('is-in'); }
    function inViewport(el, ratio){
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var vw = window.innerWidth || document.documentElement.clientWidth;
      if (r.width === 0 || r.height === 0) return false;
      var visY = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
      var visX = Math.max(0, Math.min(r.right,  vw) - Math.max(r.left, 0));
      var visible = (visX * visY) / (r.width * r.height);
      return visible >= (ratio || 0.2);
    }

    if (!enabled) { reveal(); return; }
    if (inViewport(root, 0.15)) { reveal(); return; }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        for (var k=0;k<entries.length;k++){ if(entries[k].isIntersecting){ reveal(); io.unobserve(root); } }
      }, { threshold: 0.2 });
      io.observe(root);
    } else {
      // fallback: reveal soon
      setTimeout(reveal, 200);
    }

    // extra safety reveal
    window.addEventListener('load', function(){ if(!root.classList.contains('is-in')) reveal(); });
    setTimeout(function(){ if(!root.classList.contains('is-in')) reveal(); }, 1500);
  }

  function initOne(root){
    if(!root || root.getAttribute('data-bm-init')==='1') return;
    root.setAttribute('data-bm-init','1');

    var track = root.querySelector('[data-bm-track]'); if(!track) return;
    var buttons = root.querySelectorAll('[data-bm-arrow]');
    var bar = root.querySelector('.bm-branches__progress-bar');
    var carousel = root.querySelector('.bm-branches__carousel');

    function updateProgress(){
      var max = track.scrollWidth - track.clientWidth;
      var pct = max>0 ? (track.scrollLeft/max)*100 : 0;
      if(bar) bar.style.width = pct + '%';
    }
    track.addEventListener('scroll', updateProgress, {passive:true});
    window.addEventListener('resize', updateProgress);
    updateProgress();

    function scrollStep(dir){
      var amount = getStep(track) * Number(dir||1);
      animateScrollLeft(track, track.scrollLeft + amount, 1200); // smooth glide
    }

    for(var i=0;i<buttons.length;i++){
      (function(btn){ btn.addEventListener('click', function(){ scrollStep(btn.getAttribute('data-dir')); restartAuto(); }); })(buttons[i]);
    }

    track.addEventListener('keydown', function(e){
      if(e.key==='ArrowRight' || e.key==='ArrowLeft'){
        e.preventDefault();
        scrollStep(e.key==='ArrowRight'?1:-1);
        restartAuto();
      }
    });

    // vertical wheel -> horizontal
    track.addEventListener('wheel', function(e){
      if(Math.abs(e.deltaY) > Math.abs(e.deltaX)){
        e.preventDefault();
        track.scrollLeft += e.deltaY;
        restartAuto();
      }
    }, {passive:false});

    // drag to scroll
    var down=false, startX=0, startLeft=0;
    function pd(e){ down=true; startX=(e.clientX || (e.touches&&e.touches[0].clientX) || 0); startLeft=track.scrollLeft; carousel.classList.add('dragging'); }
    function mv(e){ if(!down) return; var x=(e.clientX || (e.touches&&e.touches[0].clientX) || 0); e.preventDefault(); track.scrollLeft = startLeft - (x - startX); }
    function pu(){ down=false; carousel.classList.remove('dragging'); }

    if(window.PointerEvent){
      carousel.addEventListener('pointerdown', pd);
      window.addEventListener('pointermove', mv);
      window.addEventListener('pointerup', pu);
      window.addEventListener('pointercancel', pu);
    } else {
      carousel.addEventListener('mousedown', pd);
      window.addEventListener('mousemove', mv);
      window.addEventListener('mouseup', pu);
      carousel.addEventListener('touchstart', pd, {passive:true});
      window.addEventListener('touchmove', mv, {passive:false});
      window.addEventListener('touchend', pu);
      window.addEventListener('touchcancel', pu);
    }

    // autoplay
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var pause = root.getAttribute('data-pause') === 'true';
    var interval = Math.max(1, parseInt(root.getAttribute('data-interval') || '2', 10)) * 1000;
    var timer=null;
    function tick(){ if(atEnd(track)) animateScrollLeft(track, 0, 1200); else scrollStep(1); }
    function start(){ if(!autoplay) return; stop(); timer=setInterval(tick, interval); }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    function restartAuto(){ stop(); start(); }
    start();
    if(pause){ root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start); }
    root.addEventListener('bm:restart', restartAuto);

    // non-blocking intro animation
    initIntro(root);
  }

  function initAll(ctx){
    var scope = ctx || document;
    var nodes = scope.querySelectorAll('[data-bm-section]');
    for(var i=0;i<nodes.length;i++) initOne(nodes[i]);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  } else {
    initAll(document);
  }
  window.addEventListener('load', function(){ initAll(document); setTimeout(function(){ initAll(document); }, 0); });
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
  document.addEventListener('shopify:section:select', function(e){ initAll(e.target); });
})();
